import styled from "@emotion/styled";
import type { FC } from "react";
import { useMemo } from "react";

import { ReactComponent as BalanceIcon } from "../../../assets/balances.svg";
import { useLanguageContext } from "../../../contexts/language/language";
import { useNFTMarketsContext } from "../../../contexts/nftMarkets";
import type { CollapseControlProps } from "../../../hooks/home/useCollapseControl";
import { ChevronCollapse } from "../ChevronCollapse/ChevronCollapse";
import { NFTEscrowAccountsTable } from "./EscrowAccounts";
import { NFTPoolOrdersTable } from "./PoolOrders";
import { NFTSingleOrdersTable } from "./SingleOrders";

export const NFTMarkets: FC<CollapseControlProps> = ({ activePanels, getPanelKey, onPanelClick }) => {
  const { singleOrders, poolOrders, escrowAccounts } = useNFTMarketsContext();
  const {
    currentLanguageData: {
      pages: {
        dashboard: {
          modules: { nftMarkets },
        },
      },
    },
  } = useLanguageContext();

  const value = useMemo(
    () => singleOrders.totalValue + poolOrders.totalValue + escrowAccounts.totalValue,
    [escrowAccounts.totalValue, poolOrders.totalValue, singleOrders.totalValue],
  );

  return singleOrders.positions.length || poolOrders.positions.length || escrowAccounts.positions.length ? (
    <StyledChevronCollapse
      activePanels={activePanels}
      panelKey={getPanelKey("NFTMarkets")}
      onChange={onPanelClick}
      title={nftMarkets.title}
      value={value}
      TitleIcon={BalanceIcon}
    >
      <>
        {singleOrders.positions.length > 0 && (
          <NFTSingleOrdersTable totalValue={singleOrders.totalValue} singleOrders={singleOrders.positions} />
        )}
      </>
      <>
        {poolOrders.positions.length > 0 && (
          <NFTPoolOrdersTable totalValue={poolOrders.totalValue} poolOrders={poolOrders.positions} />
        )}
      </>
      <>
        {escrowAccounts.positions.length > 0 && (
          <NFTEscrowAccountsTable totalValue={escrowAccounts.totalValue} escrowAccounts={escrowAccounts.positions} />
        )}
      </>
    </StyledChevronCollapse>
  ) : (
    <></>
  );
};

const StyledChevronCollapse = styled(ChevronCollapse)`
  margin-top: 20px;
`;
